module.exports = __webpack_public_path__ + "static/media/1560444421414-1555646841.f7ca15fe.jpg";